import { useCallback } from "react";
import { useConfiguration } from "../hooks/useConfiguration";

/** Metric ↔ imperial toggle. */
export function UnitToggle() {
  const { config, dispatch } = useConfiguration();

  const setMetric = useCallback(
    () => dispatch({ type: "setUnits", units: "metric" }),
    [dispatch],
  );
  const setImperial = useCallback(
    () => dispatch({ type: "setUnits", units: "imperial" }),
    [dispatch],
  );

  const base =
    "min-h-11 px-3.5 text-[13px] font-medium cursor-pointer transition-colors focus-visible:outline-2 focus-visible:outline-accent focus-visible:outline-offset-2 md:min-h-0 md:py-1.5";
  const active = "bg-accent text-canvas";
  const inactive = "text-muted hover:text-ink";

  return (
    <div
      role="group"
      aria-label="Units"
      className="inline-flex overflow-hidden rounded-lg border border-border bg-panel-2"
    >
      <button
        type="button"
        onClick={setMetric}
        aria-pressed={config.units === "metric"}
        className={`${base} ${config.units === "metric" ? active : inactive}`}
      >
        Metric (km/h, m/s)
      </button>
      <button
        type="button"
        onClick={setImperial}
        aria-pressed={config.units === "imperial"}
        className={`${base} ${config.units === "imperial" ? active : inactive}`}
      >
        Imperial (kt)
      </button>
    </div>
  );
}
